export default "__VITE_ASSET__VTY_x3uU__"